import React from "react";
import styles from './StatusDetails.module.scss'
import { DEPLOYMENT_STATUSES } from "../../../../../../../settings/content/deployment";
import { DEBUG } from "../../../../../../../settings/global";
import showModalDefault from "../../../../../../../helpers/ui/ModalDefault";
import GuideModal from "../../../../../../dashboard/cells/actions/components/GuideModal";

function StatusDetails({deployment, ssl}) {

    const getStatusMessage = status => {
        if (!!Object.keys(DEPLOYMENT_STATUSES).some(s => s === status)) {
            switch (status) {
                case 'in_progress':
                    return `Deployment is in progress now. It may take up to 15 minutes.`;
                case 'completed':
                    return (
                        <span>
                        Deployment complete. <a onClick={() => {
                            showModalDefault({
                                component: <GuideModal seo={ssl}/>,
                                title: `What is next?`,
                                maxWidth: '1200px'
                            })
                        }}>What is next?</a>
                    </span>
                    );
                case 'failed':
                    return <span>Deployment has failed. Check your e-mail box for error reason or <a onClick={() => Tawk_API.toggle({start: ''})}>contact support</a>.</span>;
                case 'wait_payment':
                    return `Deployment will continue after required plan upgrade.`;
                case 'wait_resume':
                    return `Resume install in actions`;
                case 'wait_single_payment':
                    return `Deployment can be continued after purchase. See "action" column.`;
                case 'paused':
                    return <span>Deployment paused due to an error.  Check e-mail for the error reason or <a onClick={() => Tawk_API.toggle({start: ''})}>contact tech support</a></span>;
                default:
                    return `Unknown deployment status.${!!DEBUG && ' For correct display, it should be handled in "StatusDetails.jsx" component first.'}`
            }
        } else {
            return `Unknown deployment status.${!!DEBUG && ' Please add it to "settings/deployments.js first"'}`
        }
    }

    return (
        <div className={styles.status}>
            {getStatusMessage(deployment.status)}
        </div>
    )
}

export default StatusDetails